import { action, observable } from 'mobx';
import { events, on } from 'elc-service-bus';

export interface ILimitReachedEventData {
    itemMaxQuantity: number;
}

export class CartLimitReachedModalController {
    @observable public shouldDisplayModal: boolean = false;
    @observable public maxSkuLimit: number = 0;

    @action public toggleModal(newState: boolean) {
        this.shouldDisplayModal = newState;
    }

    @action public handleSkuLimitReached(maxSkuLimit: number) {
        this.maxSkuLimit = maxSkuLimit;
        this.toggleModal(true);
    }

    @on(events.CART_PRODUCT_SKU_LIMIT_REACHED)
    public cartSKULimitReached = ({ itemMaxQuantity }: ILimitReachedEventData) => {
        this.handleSkuLimitReached(itemMaxQuantity);
    };
}
